import { LayerUI } from '@App/app/entities/layer/layer-ui.model';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { catchError, map, tap, withLatestFrom } from 'rxjs/operators';
import { ViewerLayerService } from '../../../../engine/services/layer-services/viewer-layer-service/viewer-layer.service';
import {
  hideLayer,
  hideLayers,
  showLayer,
  showLayers,
  updateLayers,
} from '../actions/layers.actions';
import { selectAllLayers } from '../selectors/layers.selectors';

@Injectable()
export class VisibilityLayerEffects {
  constructor(
    private actions: Actions,
    private viewerLayerService: ViewerLayerService,
    private store: Store,
  ) {}

  showLayer = createEffect(
    () => {
      return this.actions.pipe(
        ofType(showLayer),
        withLatestFrom(this.store.select(selectAllLayers)),
        tap(([{ id }, layers]) => {
          const layer = layers.find((item) => item.id === id) as LayerUI;
          this.viewerLayerService.showLayer(layer);
        }),
      );
    },
    { dispatch: false },
  );

  showLayers = createEffect(() => {
    return this.toggleLayersVisibility(showLayers, true);
  });

  hideLayer = createEffect(
    () => {
      return this.actions.pipe(
        ofType(hideLayer),
        tap((payload) => {
          this.viewerLayerService.hideLayer(payload.id);
        }),
      );
    },
    { dispatch: false },
  );

  hideLayers = createEffect(() => {
    return this.toggleLayersVisibility(hideLayers, false);
  });

  private toggleLayersVisibility(
    actionType: typeof showLayers | typeof hideLayers,
    isVisible: boolean,
  ) {
    return this.actions.pipe(
      ofType(actionType),
      withLatestFrom(this.store.select(selectAllLayers)),
      map(
        ([{ ids }, layers]) => {
          const layersToUpdate = layers.filter((item) => ids.includes(item.id));
          if (isVisible) {
            this.viewerLayerService.showLayers(layersToUpdate);
          } else {
            this.viewerLayerService.hideLayers(layersToUpdate);
          }
          const updates = layersToUpdate.map((layer) => {
            return {
              id: layer.id,
              changes: { isVisible },
            };
          });
          return updateLayers({ updates });
        },
        catchError(() => EMPTY),
      ),
    );
  }
}
